import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchMovieFilterInterface } from '../shared/entities/search-movie-filter.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';

@Component({
  selector: 'search-movie-filter-item',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, SharedUtilsTranslationModule],
  template: `
    <fa-icon [icon]="searchMovieFilter.icon"></fa-icon>
    @if (!iconOnly) {
      <span [attr.data-translate]="searchMovieFilter.labelTranslationKey">{{
        searchMovieFilter.labelTranslationKey | translate
      }}</span>
    }
  `,
  styleUrl: './search-movie-filter-item.component.scss'
})
export class SearchMovieFilterItemComponent {
  @Input({ required: true }) searchMovieFilter!: SearchMovieFilterInterface;
  @Input() iconOnly = false;
  @HostBinding('class.icon-only') get isIconOnly() {
    return this.iconOnly;
  }
}
